import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInbox } from "@fortawesome/free-solid-svg-icons";

const EmptyState = ({ title = "No data available" }) => {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center text-center"
      style={{ minHeight: "250px" }}
    >
      <FontAwesomeIcon
        icon={faInbox}
        style={{ fontSize: "48px", color: "#6c757d" }}
      />
      <h6 className="mt-3 fw-semibold text-muted">{title}</h6>
      <p className="mt-1 small text-muted mb-0">Try adjusting your filters.</p>
    </div>
  );
};

export default EmptyState;
